import { render, staticRenderFns } from "./referalsProfitModal.vue?vue&type=template&id=27403d5e&"
import script from "./referalsProfitModal.vue?vue&type=script&lang=js&"
export * from "./referalsProfitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports